import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { NavDropdown, MenuItem } from 'react-bootstrap';
import './navBar.scss';
import fullLogo from '../images/full-logo_ppa.svg';

export default class NavBar extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      loggedIn: PropTypes.bool.isRequired
    }).isRequired,
    profile: PropTypes.shape({
      staff: PropTypes.bool,
      beta: PropTypes.bool
    }),
    isHome: PropTypes.bool.isRequired,
    logoutOnly: PropTypes.bool.isRequired
  };

  static contextTypes = {
    location: PropTypes.object.isRequired
  };

  _openHelp() {
    /* For some reasons an "a href" doesn't work from inside the hamburger menu, so we use this */
    window.open("https://help.planetprotectoracademy.com", "_blank");
  }

  render () {
    const {
      auth: {
        loggedIn
      },
      profile: {
        staff
      },
      isHome,
      logoutOnly
    } = this.props;
    const { query } = this.context.location;
    const isLanding = isHome && !loggedIn;
    const navheaderdisplay = this.context.location.pathname === '/' && loggedIn
      ? 'MY PROGRAMS'
      : this.context.location.pathname === '/programs'
          ? 'OTHER PROGRAMS'
          : this.context.location.pathname === '/profile'
              ? 'EDIT PROFILE'
              : this.context.location.pathname.startsWith('/staff')
                ? 'STAFF AREA'
                : this.context.location.pathname === '/unsubscribe'
                  ? 'UNSUBSCRIBE'
                  : this.context.location.pathname === '/unsubscribed'
                    ? 'UNSUBSCRIBED'
                    : this.context.location.pathname == '/invite'
                      ? 'INVITE A FRIEND'
                      : '';
    const canInvite = true;

    if (isLanding) {
      return (
        <nav className="navbar navbar-landing">
          <ul className="nav navbar-nav navbar-right">
            <li>
            </li>
          </ul>
        </nav>
      );
    }

    if (screen.width < 400 && loggedIn) {
      return (
        <nav
          className={`navbar navbar-default mobileNav ${
            navheaderdisplay
              ? 'logged-in'
              : 'logged-out'
          }`}
          role="navbar"
        >
          <div className="container-fluid mobileNav">
            <div className="branding navbar-left col-xs-6 mobileNavLogo">
              <Link to="/" activeClassName="active">
                <img src={fullLogo} />
              </Link>
            </div>
            <ul className={`nav navbar-nav navbar-right col-xs-1 ${
              screen.width <= 768
                ? 'mobileXs'
                : ''
            }`}>
              <NavDropdown
                className="hamburger-menu"
                eventKey="4"
                title={
                  <span className="glyphicon glyphicon-menu-hamburger"></span>
                }
                id="nav-dropdown"
              >
                {loggedIn && !logoutOnly &&
                  <MenuItem eventKey="4.1">
                    <Link
                      className={isHome ? 'active' : ''}
                      to="/"
                      query={query}>
                     My Programs
                    </Link>
                  </MenuItem>
                }
                {loggedIn && !logoutOnly &&
                  <MenuItem eventKey="4.2">
                    <Link to="/programs" query={query} activeClassName="active">
                      Other Programs
                    </Link>
                 </MenuItem>
                }
                {loggedIn && staff && !logoutOnly &&
                  <MenuItem eventKey="4.3">
                    <Link to="/staff" activeClassName="active">
                      Staff
                    </Link>
                  </MenuItem>
                }
                {loggedIn && !logoutOnly &&
                  <MenuItem eventKey="4.4">
                    <Link to="/profile" query={query} activeClassName="active">
                      Profile
                    </Link>
                  </MenuItem>
                }
                {loggedIn && !logoutOnly &&
                  <MenuItem eventKey="4.5">
                    <a onClick={::this._openHelp}>
                      Help
                    </a>
                  </MenuItem>
                }
                {!loggedIn &&
                  <MenuItem eventKey="4.6">
                    <Link to="/register" query={query} activeClassName="active" className="btn btn-lg btn-success">
                      Register
                    </Link>
                  </MenuItem>
                }
                {loggedIn ?
                  <MenuItem eventKey="4.7">
                    <Link to="/logout" activeClassName="active">
                      Sign out
                    </Link>
                  </MenuItem>
                :
                  <MenuItem eventKey="4.7">
                    <Link to="/signin" query={query} activeClassName="active" className="btn btn-lg btn-success">
                      Sign in
                    </Link>
                  </MenuItem>
                }
                {loggedIn && canInvite && !logoutOnly &&
                <MenuItem eventKey="4.8">
                  <Link to="/invite" activeClassName="active">
                    Invite
                  </Link>
                </MenuItem>
                }
              </NavDropdown>
            </ul>
          </div>
        </nav>
      );
    } else if (screen.width < 992 && loggedIn) {
      return (
        <div className="navbar-container">
          <nav
            className={`navbar navbar-default mobileNav ${
              navheaderdisplay
                ? 'logged-in'
                : 'logged-out'
            }`}
            role="navbar"
          >
            <div className="container-fluid">
              <div className="branding navbar-left col-xs-6">
                <Link to="/" activeClassName="active">
                  <img src={fullLogo} />
                </Link>
              </div>
              <ul className={`nav navbar-nav navbar-right col-xs-2 ${
                screen.width <= 768
                  ? 'mobileXs'
                  : ''
              }`}>
                <NavDropdown
                  className="hamburger-menu"
                  eventKey="4"
                  title={
                    <span className="glyphicon glyphicon-menu-hamburger"></span>
                  }
                  id="nav-dropdown"
                >
                  {loggedIn && !logoutOnly &&
                    <MenuItem eventKey="4.1">
                      <Link
                        className={isHome ? 'active' : ''}
                        to="/"
                        query={query}>
                      My Programs
                      </Link>
                    </MenuItem>
                  }
                  {loggedIn && !logoutOnly &&
                    <MenuItem eventKey="4.2">
                      <Link to="/programs" query={query} activeClassName="active">
                        Other Programs
                      </Link>
                   </MenuItem>
                  }
                  {loggedIn && staff && !logoutOnly &&
                    <MenuItem eventKey="4.4">
                      <Link to="/staff" activeClassName="active">
                        Staff
                      </Link>
                    </MenuItem>
                  }
                  {loggedIn && !logoutOnly &&
                    <MenuItem eventKey="4.5">
                      <Link to="/profile" query={query} activeClassName="active">
                        Profile
                      </Link>
                    </MenuItem>
                  }
                  {loggedIn && !logoutOnly &&
                    <MenuItem eventKey="4.6">
                      <a onClick={::this._openHelp}>
                        Help
                      </a>
                    </MenuItem>
                  }
                  {!loggedIn &&
                    <MenuItem eventKey="4.7">
                      <Link to="/register" query={query} activeClassName="active" className="btn btn-lg btn-success">
                        Register
                      </Link>
                    </MenuItem>
                  }
                  {loggedIn ?
                    <MenuItem eventKey="4.8">
                      <Link to="/logout" activeClassName="active">
                        Sign out
                      </Link>
                    </MenuItem>
                  :
                    <MenuItem eventKey="4.8">
                      <Link to="/signin" query={query} activeClassName="active" className="btn btn-lg btn-success">
                        Sign in
                      </Link>
                    </MenuItem>
                  }
                  {loggedIn && canInvite && !logoutOnly &&
                  <MenuItem eventKey="4.9">
                    <Link to="/invite" activeClassName="active">
                      Invite
                    </Link>
                  </MenuItem>
                  }
                </NavDropdown>
              </ul>
            </div>
          </nav>
          {navheaderdisplay && <div className="navbar-page-header">{navheaderdisplay}</div>}
        </div>
      );
    } else {
      return (
        <div className="navbar-container">
          <nav className={`navbar navbar-default ${
            navheaderdisplay
              ? 'logged-in'
              : 'logged-out'
          }`}>
            <div className="container-fluid">
              <div className="branding navbar-left">
                <Link to="/" activeClassName="active">
                  <img src={fullLogo} />
                </Link>
              </div>
              <ul className="nav navbar-nav navbar-right">
                {loggedIn && !logoutOnly &&
                  <li>
                    <Link
                      className={isHome ? 'active' : ''}
                      to="/"
                      query={query}>
                   My Programs
                    </Link>
                  </li>
                }
                {loggedIn && !logoutOnly &&
                  <li>
                    <Link to="/programs" query={query} activeClassName="active">
                      Other Programs
                    </Link>
                  </li>
                }
                {loggedIn && staff && !logoutOnly &&
                  <li>
                    <Link to="/staff" activeClassName="active">
                      Staff
                    </Link>
                  </li>
                }
                {loggedIn && !logoutOnly &&
                  <li>
                    <Link to="/profile" query={query} activeClassName="active">
                      Profile
                    </Link>
                  </li>
                }
                {loggedIn && !logoutOnly &&
                  <li>
                    <a onClick={::this._openHelp}>
                      Help
                    </a>
                  </li>
                }
                {!loggedIn &&
                  <li>
                    <Link to="/register" query={query} activeClassName="active" className="btn btn-lg btn-success">
                      Register
                    </Link>
                  </li>
                }
                {loggedIn ?
                  <li>
                    <Link to="/logout" activeClassName="active">
                      Sign out
                    </Link>
                  </li>
                :
                  <li>
                    <Link to="/signin" query={query} activeClassName="active" className="btn btn-lg btn-success">
                      Sign in
                    </Link>
                  </li>
                }
                {loggedIn && canInvite && !logoutOnly &&
                <li>
                  <Link to="/invite" className="btn btn-lg btn-success">
                    Invite
                  </Link>
                </li>
                }
              </ul>
            </div>
          </nav>
          {navheaderdisplay && <div className="navbar-page-header">{navheaderdisplay}</div>}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/navBar.jsx